module.exports = __webpack_public_path__ + "img/prime.d06bf622.png";